import { z } from 'zod'

import { getJson, postJson } from '../client'
import { API } from '../paths'
import {
  loginResponseSchema,
  tokenPairSchema,
  userSchema,
  type LoginRequest,
  type LoginResponse,
  type TokenPair,
  type User,
} from '../schemas/auth'

export const authApi = {
  login: (credentials: LoginRequest): Promise<LoginResponse> =>
    postJson(API.auth.login, credentials, loginResponseSchema, { skipAuth: true }),

  refresh: (refreshToken: string): Promise<TokenPair> =>
    postJson(API.auth.refresh, { refresh_token: refreshToken }, tokenPairSchema, {
      skipAuth: true,
    }),

  logout: (refreshToken: string | null): Promise<unknown> =>
    postJson(API.auth.logout, { refresh_token: refreshToken }, z.unknown()),

  me: (): Promise<User> => getJson(API.auth.me, userSchema),
}
